import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import styles from "./styles.module.css";

const BusinessProfile = (props) => {
  const handleSubmit = (values) => {
    props.next(values);
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is a required field"),
    state: Yup.string().required("State is a required field"),
    population: Yup.string().min(2).required("Population is a required field"),
  });

  return (
    <div className="businessprofile-cover">
      <h2>Let’s build your Council profile</h2>
      {/* <button type="button" onClick={setName}>
        Set Name
      </button> */}
      {/* <form onSubmit={formik.handleSubmit} className="business-profile-form">
        <div className="form-group">
          <label htmlFor="name">Council Name</label>
          <input
            type="text"
            name="name"
            id="name"
            // disabled={props.isCouncilNameDisabled}
            disabled
            className={`form-control ${styles.councilName}`}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.name}
            ref={nameInputRef}
          />

          {formik.touched.name && formik.errors.name ? (
            <div className="error-message">{formik.errors.name}</div>
          ) : null}
        </div>

        <div className="form-group">
          <label htmlFor="state">State</label>
          <div className="search-group">
            <input
              name="state"
              id="state"
              type="text"
              className="form-control"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.state}
            />
            <div className="search-icon">
              <img src={search} alt="search icon" />
            </div>
          </div>
          {formik.touched.state && formik.errors.state ? (
            <div className="error-message">{formik.errors.state}</div>
          ) : null}
        </div>

        <div className="form-group">
          <label htmlFor="population">Population</label>

          <select
            id="population"
            name="population"
            className="form-control"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.population}
          >
            <option value="">Select</option>
            <option value="1 - 1000">1 - 1000</option>
            <option value="1001 - 5000">1001 - 5000</option>
            <option value="5001 - 10000">5001 - 10000</option>
            <option value="10001 - 25000">10001 - 25000</option>
            <option value="25001 - 50000">25001 - 50000</option>
            <option value="100001 - 150000">100001 - 150000</option>
            <option value="150001 - 250000">150001 - 250000</option>
            <option value="250001 - 500000">250001 - 500000</option>
            <option value="500001 - 1000000">500001 - 1000000</option>
            <option value="1000000+">1000000+</option>
          </select>
          {formik.touched.population && formik.errors.population ? (
            <div className="error-message">{formik.errors.population}</div>
          ) : null}
        </div>
        <div className="form-submit">
          <button type="submit" className="submit-btn">
            Next
          </button>
        </div>
      </form> */}

      <Formik
        initialValues={props.data}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize={true}
      >
        {() => {
          return (
            <Form className="business-profile-form">
              <div className="form-group">
                <label>Council Name</label>
                <Field
                  disabled={props.isCouncilNameDisabled}
                  name="name"
                  type="text"
                  className={`form-control ${styles.councilName}`}
                />
                <ErrorMessage
                  name="name"
                  component="div"
                  className="error-message"
                />
              </div>
              <div className="form-group">
                <label>State</label>
                <div className="search-group">
                  <Field name="state" type="text" className="form-control" />
                  {/* <div className="search-icon">
                    <img src={search} alt="search icon" />
                  </div> */}
                </div>
                <ErrorMessage
                  name="state"
                  component="div"
                  className="error-message"
                />
              </div>
              <div className="form-group">
                <label>Population</label>

                <Field name="population" as="select" className="form-control">
                  <option value="">Select</option>
                  <option value="1 - 1000">1 - 1000</option>
                  <option value="1001 - 5000">1001 - 5000</option>
                  <option value="5001 - 10000">5001 - 10000</option>
                  <option value="10001 - 25000">10001 - 25000</option>
                  <option value="25001 - 50000">25001 - 50000</option>
                  <option value="50001 - 100000">50001 - 100000</option>
                  <option value="100001 - 150000">100001 - 150000</option>
                  <option value="150001 - 250000">150001 - 250000</option>
                  <option value="250001 - 500000">250001 - 500000</option>
                  <option value="500001 - 1000000">500001 - 1000000</option>
                  <option value="1000000+">1000000+</option>
                </Field>

                <ErrorMessage
                  name="population"
                  component="div"
                  className="error-message"
                />
              </div>
              <div className="form-submit">
                <button type="submit" className="submit-btn">
                  Next
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default BusinessProfile;
